import React from "react";
import { useWindowSize } from "../HelperHooks";

export default function ClockHand({ chart, currentAudioTime }) {
    useWindowSize();

    if (!chart.current || currentAudioTime === 0) {
        return null;
    }

    const rotation = (((currentAudioTime / 3600) * 360 + 360) % 360) + 180;

    const styles = {
        top: `${chart.current.height / 2 + 25}px`,
        left: `${chart.current.width / 2}px`,
        height: `${Math.min(chart.current.chartArea.width, chart.current.chartArea.height) / 2 - 3}px`,
        transform: `rotate(${rotation}deg)`,
    };

    return <div style={styles} className="clock-hand"></div>;
}
